{
  "badges": {
    "shared": "Deles med partner",
    "transferable": "Overdras",
    "requiresDocumentation": "Må dokumenteres"
  },
  "summary": {
    "obligatoryShareCapital": "Pliktig andelskapital",
    "owedShareCapital": "Skyldig andelskapital",
    "annualFee": "Serviceavgift",
    "annualFeeCurrent": "Serviceavgift i år",
    "ofTotal": "Av totalt {{total}}"
  },
  "closeTransferForm": {
    "title": "Vil du avbryte overføringen av andeler?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt overføring",
    "cancelLabel": "Lukk"
  },
  "closeEndShareownershipForm": {
    "title": "Vil du avbryte avslutningen av andelseierskapet?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt avslutning",
    "cancelLabel": "Lukk"
  },
  "partner": {
    "step2": {
      "allPropertiesConfirmed": {
        "error": "Du må bekrefte at du har registrert alle eiendommene til partner."
      }
    }
  }
}
